import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function proQueryPatientConsent(
  patientUserId: string,
): Promise<PatientConsent> {
  const res = await fetchOrchidAPI(
    `/api/users/v1/orchid_pro/patient_consent/patient/${patientUserId}`,
  );
  if (!res.ok) {
    throw new Error(
      `failed to fetch patient consent: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
